var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagramSocialMedia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#3182FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 23C21.6569 23 23 21.6569 23 20C23 18.3431 21.6569 17 20 17C18.3431 17 17 18.3431 17 20C17 21.6569 18.3431 23 20 23Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.125 10.625H15.875C14.4831 10.6266 13.1487 11.1802 12.1644 12.1644C11.1802 13.1487 10.6266 14.4831 10.625 15.875V24.125C10.6266 25.5169 11.1802 26.8513 12.1644 27.8356C13.1487 28.8198 14.4831 29.3734 15.875 29.375H24.125C25.5169 29.3734 26.8513 28.8198 27.8356 27.8356C28.8198 26.8513 29.3734 25.5169 29.375 24.125V15.875C29.3734 14.4831 28.8198 13.1487 27.8356 12.1644C26.8513 11.1802 25.5169 10.6266 24.125 10.625ZM20 24.5C19.11 24.5 18.24 24.2361 17.4999 23.7416C16.7599 23.2471 16.1831 22.5443 15.8425 21.7221C15.5019 20.8998 15.4128 19.995 15.5865 19.1221C15.7601 18.2492 16.1887 17.4474 16.818 16.818C17.4474 16.1887 18.2492 15.7601 19.1221 15.5865C19.995 15.4128 20.8998 15.5019 21.7221 15.8425C22.5443 16.1831 23.2471 16.7599 23.7416 17.4999C24.2361 18.24 24.5 19.11 24.5 20C24.4987 21.1931 24.0241 22.3369 23.1805 23.1805C22.3369 24.0241 21.1931 24.4987 20 24.5ZM24.875 16.25C24.6525 16.25 24.435 16.184 24.25 16.0604C24.065 15.9368 23.9208 15.7611 23.8356 15.5555C23.7505 15.35 23.7282 15.1238 23.7716 14.9055C23.815 14.6873 23.9222 14.4868 24.0795 14.3295C24.2368 14.1722 24.4373 14.065 24.6555 14.0216C24.8738 13.9782 25.1 14.0005 25.3055 14.0856C25.5111 14.1708 25.6868 14.315 25.8104 14.5C25.934 14.685 26 14.9025 26 15.125C26 15.4234 25.8815 15.7095 25.6705 15.9205C25.4595 16.1315 25.1734 16.25 24.875 16.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramSocialMedia);
export default __webpack_public_path__ + "static/media/instagramSocialMedia.c50bf7bdbbdaea469ee28971e620d4bc.svg";
export { ForwardRef as ReactComponent };